import { apiSlice } from 'src/features/api/api-slice';

interface GoogleOneTapAuthRequest {
  credential: string;
  nonce: string;
  referrerUsername?: string;
  fingerprint?: string;
}

export interface GoogleOneTapAuthResponse {
  success: boolean;
  user: {
    id: string;
    email: string;
    username: string;
    isNew: boolean;
    avatar: string;
    fullName: string;
    isB2BAdmin: boolean;
    companyId: string;
  };
}

export const authApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    googleOneTapAuth: builder.mutation<GoogleOneTapAuthResponse, GoogleOneTapAuthRequest>({
      query: (body) => ({
        url: '/auth/google-one-tap/authenticate',
        method: 'POST',
        body,
      }),
    }),
  }),
});

export const { useGoogleOneTapAuthMutation } = authApi;
